type Listener = () => void;
type ActivityListener = (at: number) => void;

const unauthenticatedListeners = new Set<Listener>();
const activityListeners = new Set<ActivityListener>();
let lastSuccessAt = 0;

/** The shell subscribes to react to a 401 from any request (e.g. redirect to /login). */
export function onUnauthenticated(listener: Listener): () => void {
  unauthenticatedListeners.add(listener);
  return () => unauthenticatedListeners.delete(listener);
}

export function emitUnauthenticated(): void {
  for (const listener of unauthenticatedListeners) listener();
}

/**
 * Epoch ms of the last API call that the backend answered successfully (2xx).
 * The backend session's idle timer restarts on every such call, so the shell
 * uses this to keep active users signed in and to warn before expiry.
 * 0 when there has been none yet.
 */
export function getLastApiSuccessAt(): number {
  return lastSuccessAt;
}

/** Subscribe to successful API calls (receives the timestamp). */
export function onApiSuccess(listener: ActivityListener): () => void {
  activityListeners.add(listener);
  return () => activityListeners.delete(listener);
}

/**
 * Records server activity observed elsewhere (e.g. another tab of the same
 * session). Only moves the timestamp forward.
 */
export function noteApiActivity(at: number): void {
  if (at <= lastSuccessAt) return;
  lastSuccessAt = at;
  for (const listener of activityListeners) listener(at);
}
